<div class="circle-char">{{ char }}</div>
